import React from 'react';
import PageLayout from '../components/common/PageLayout';
import CashCounterPanel from '../components/finance/cash-counter/CashCounterPanel';

const CashCounterPage = () => (
  <PageLayout
    title="Cash Counter"
    showFinanceSectionTabs
    showBreadcrumbs={false}
    navLinks={[
      { url: '/finance/reports/', label: 'Reports' },
      { url: '/finance/rates/', label: 'Manage Rate' },
    ]}
  >
    <CashCounterPanel />
  </PageLayout>
);

export default CashCounterPage;
